import { toast } from 'sonner';

/**
 * Show an API error. Plan limits (HTTP 402) get an "Upgrade" action that
 * opens the plans page. Returns the message that was shown.
 */
export function showApiError(err, t) {
  const detail = err?.response?.data?.detail;
  let message = t('common.error');
  if (typeof detail === 'string') message = detail;
  else if (detail && typeof detail === 'object' && !Array.isArray(detail) && detail.message) message = detail.message;
  else if (Array.isArray(detail)) message = t('service.validation.form');

  if (err?.response?.status === 402) {
    toast.error(message, {
      duration: 8000,
      action: { label: t('upgrade.upgradeLabel'), onClick: () => window.location.assign('/quote-upgrade') },
    });
  } else {
    toast.error(message);
  }
  return message;
}
